//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'box',
  props: {
    type: {
      default: ''
    },
    top: {
      type: String,
      default: ''
    },
    bottom: {
      default: ''
    },
    num: {
      default: ''
    },
    isimage: {
      type: Boolean,
      default: false
    },
    image: {
      default: ''
    }
  },
  data () {
    return {}
  },
  created () { },
  mounted () { },
  methods: {
  }
}
